import { mapGetters } from 'vuex';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import mvtSaleProceeds from '@/common/components/mvtsaleproceeds/mvt-saleproceeds.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';

export default {
    name: 'pagehomesalecalc',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        mvtDialogCenter,
        mvtSaleProceeds,
        mvtHeader,
        mvtFooter,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    mounted() {
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
};
